import queryString from 'query-string'
import { handleActions } from 'redux-actions'
import languages from '../../configuration/languages'
import {
  SET_SESSION_ID,
  SET_SESSION_CURRENCY,
  SET_SESSION_LANGUAGE,
  START_SESSION_TIMER,
  RESET_START_SESSION_TIMER,
  SESSION_ID_STORAGE_KEY
} from './constants'
import { DEFAULT_LANG } from '../user/constants'

const queryParams = queryString.parse(window.location.search)

const lang =
  queryParams?.language &&
  Object.keys(languages).some(language => language === queryParams?.language)
    ? queryParams.language
    : DEFAULT_LANG

const sessionDataInitialState = {
  sessionId: null,
  currency: 'CAD',
  language: lang,
  startSessionTimer: false
}

const sessionDataReducer = handleActions(
  {
    [SET_SESSION_ID]: (state, { payload }) => {
      const copiedState = {
        ...state
      }
      if (payload) {
        window.sessionStorage.setItem(SESSION_ID_STORAGE_KEY, payload)
        copiedState.sessionId = payload
      }

      return copiedState
    },
    [START_SESSION_TIMER]: state => ({
      ...state,
      startSessionTimer: true
    }),
    [RESET_START_SESSION_TIMER]: state => ({
      ...state,
      startSessionTimer: false
    }),
    [SET_SESSION_LANGUAGE]: (state, { payload }) => {
      const stateCopy = { ...state }
      if (payload) {
        sessionStorage.setItem('language', payload)
        stateCopy.language = payload
      }

      return stateCopy
    },
    [SET_SESSION_CURRENCY]: (state, { payload }) => ({
      ...state,
      currency: payload
    })
  },
  { ...sessionDataInitialState }
)

export { sessionDataInitialState }
export default sessionDataReducer
